import LANGUAGES from 'constants/languages'

export function labelFromLocale(locale) {
  return LANGUAGES.filter((l) => l.value === locale)[0].label
}
